export class URLPaths {

  static adjustPathToWeb(path : string) : string {

    // Encode all the characters
    const encodeResult = encodeURIComponent(path);

    let resultTemp = encodeResult.replaceAll("'", '%27');
    resultTemp = resultTemp.replaceAll('(', '%28');
    resultTemp = resultTemp.replaceAll(')', '%29');

    // Leave the back slashes
    const result = resultTemp.replaceAll('%2F', '/');

    return result;
  }
}
